import { track } from "~/modules/analytics/track";
import { McpUserEvents } from "~/modules/analytics/events/mcp";
import type { McpClientAuth, McpClientId } from "./lib/mcp-clients";

// // // //
// Typed wrappers around `track()` for the MCP setup flow. Consume via
// `import * as Analytics from "~/modules/mcp/analytics"`.

/**
 * trackSelectClient
 * Fires when the user picks an MCP client, either from the setup guide's
 * segmented control or the connect wizard's client selector.
 */
export function trackSelectClient(props: {
    location: "guide" | "wizard";
    client: McpClientId;
}) {
    track(McpUserEvents.SelectClient, props);
}

/**
 * trackOpenConnectWizard
 * Fires when the connect wizard is opened, seeded with a client.
 */
export function trackOpenConnectWizard(props: { client: McpClientId }) {
    track(McpUserEvents.OpenConnectWizard, props);
}

/**
 * trackCreateConnectionAttempted
 * Fires when the user submits the connect form to generate a credential.
 */
export function trackCreateConnectionAttempted(props: {
    client: McpClientId;
    authType: McpClientAuth;
}) {
    track(McpUserEvents.CreateConnectionAttempted, props);
}

/**
 * trackCreateConnectionSuccess
 * Fires when the credential (OAuth client + secret, or API key) is created.
 */
export function trackCreateConnectionSuccess(props: {
    client: McpClientId;
    authType: McpClientAuth;
}) {
    track(McpUserEvents.CreateConnectionSuccess, props);
}

/**
 * trackCreateConnectionError
 * Fires when credential creation fails.
 */
export function trackCreateConnectionError(props: {
    client: McpClientId;
    authType: McpClientAuth;
}) {
    track(McpUserEvents.CreateConnectionError, props);
}
